/**
 * Product Card Controller
 * This controller is required to handle functionality from
 * within a product card. This includes the likes of quick cart etc.
 */

import { Controller } from "stimulus";
import { CartLineItem } from "../components";

export default class extends Controller {
  static targets = [
    "quickCart",
    "lineItem",
    "lineItems",
    "emptyCartMessage",
    "errorMessage",
    "subtotal",
  ];

  connect() {
    this.isOpen = false;
  }

  addToCart(items = []) {
    return fetch("/cart/add.js", {
      method: "post",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    });
  }

  async getCartData(e) {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (res.ok) {
      const data = await res.json();
      await this.buildCart(data);
      await this.handleSubtotal(data);
      !this.isOpen && this.toggleCart();
      this.updateBasketTotal(data);
    } else {
      this.toggleCart(e);
      this.errorMessageTarget.classList.remove("hidden");
      console.error("Problem performing AJAX", res);
    }
  }

  updateBasketTotal(data) {
    document
      .querySelectorAll(".header__basket-count")
      .forEach((elem) => (elem.innerText = data.item_count));
  }

  toggleCart(e) {
    if (e) {
      e.preventDefault();
    }

    this.isOpen = !this.isOpen;
    this.quickCartTarget.classList.toggle("quick-cart-wrap--is-open");

    document.body.classList.toggle("no-scroll");
    document.documentElement.classList.toggle("no-scroll");
  }

  async buildCart(cartData) {
    if (cartData?.items?.length > 0) {
      if (!this.emptyCartMessageTarget.classList.contains("hidden")) {
        this.emptyCartMessageTarget.classList.add("hidden");
      }
    }

    if (this.lineItemsTarget.classList.contains("hidden")) {
      this.lineItemsTarget.classList.remove("hidden");
    }

    this.lineItemsTarget.innerHTML = `${cartData.items
      .map(function (item) {
        return CartLineItem(item, cartData, null);
      })
      .join("")}`;
  }

  async handleSubtotal(cartData) {
    this.subtotalTarget.innerText = `${document.body.dataset.currency}${(
      cartData.items_subtotal_price / 100
    ).toFixed(2)}`;
  }

  hideErrorMessage() {
    this.errorMessageTarget.classList.add("hidden");
  }

  handleLineItemStock(quantity = null, lineItem = null) {
    const variantId = lineItem.dataset.lineItemVariantValue;
    const items = Array.from(this.lineItemsTarget?.children);

    const targets =
      items?.length > 0 &&
      items.filter((item) => item.dataset.lineItemVariantValue === variantId);

    if (targets.length > 0) {
      targets.forEach((target) => {
        if (
          target.dataset.lineItemKeyValue !== lineItem?.dataset.lineItemKeyValue
        ) {
          const itemInput = target ? target.querySelector("input") : null;

          const totalQuantity =
            targets
              .map((item) => parseInt(item.dataset.quantity))
              .reduce((a, b) => a + b) || 0;
          const inventory = parseInt(itemInput.dataset.variantInventory);

          itemInput.max = inventory - totalQuantity + parseInt(itemInput.value);
          if (itemInput.value < itemInput.max) {
            itemInput.nextElementSibling.disabled = false;
          } else {
            itemInput.nextElementSibling.disabled = true;
          }
        }
      });
    }
  }

  setMessage() {
    if (this.lineItemsTarget.children.length > 0) {
      if (this.lineItemsTarget.classList.contains("hidden")) {
        this.lineItemsTarget.classList.remove("hidden");
        this.emptyCartMessageTarget.classList.add("hidden");
      }
    } else {
      this.lineItemsTarget.classList.add("hidden");
      this.emptyCartMessageTarget.classList.remove("hidden");
    }
  }

  get productController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "product";
    });
  }

  get quickshopController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "quickshop";
    });
  }

  get cartController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "cart";
    });
  }

  get uiController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "ui";
    });
  }
}
